// src/pages/CreateAnnouncement.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./CreateAnnouncementPage.css";
import apiClient from "../utils/apiClient"; // ✅ centralized API client
import SessionHandler from "../components/SessionHandler"; // ✅ global session expiry modal

const CreateAnnouncement = () => {
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [department, setDepartment] = useState("");
  const [validUpto, setValidUpto] = useState("");
  const [error, setError] = useState("");
  const [showDialog, setShowDialog] = useState(false); // ✅ dialog state

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!title || !message || !validUpto) {
      setError("All fields except department are required.");
      return;
    }

    try {
      const data = await apiClient("/announcements/", {
        method: "POST",
        body: JSON.stringify({
          title,
          message,
          department: department || null,
          valid_upto: validUpto,
        }),
      });

      if (!data) return; // session expired handled globally

      // ✅ Clear form
      setTitle("");
      setMessage("");
      setDepartment("");
      setValidUpto("");
      setError("");

      // ✅ Show success dialog
      setShowDialog(true);
    } catch (error) {
      console.error("Error creating announcement:", error);
      setError("❌ Failed to create announcement. Please try again.");
    }
  };

  const handleDialogOk = () => {
    setShowDialog(false);
    navigate("/dashboard/ManagerAcess/hrannoucementpage"); // ✅ navigate to announcements page
  };

  return (
    <div className="create-announcement-container">
      <form className="announcement-form" onSubmit={handleSubmit}>
        <h2>Create Announcement</h2>

        {error && <p className="error-message">{error}</p>}

        <label>Title *</label>
        <input
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
        />

        <label>Message *</label>
        <textarea
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          required
        />

        <label>Valid Upto *</label>
        <input
          type="date"
          value={validUpto}
          onChange={(e) => setValidUpto(e.target.value)}
          required
        />

        <label>Department (optional)</label>
        <input
          value={department}
          onChange={(e) => setDepartment(e.target.value)}
        />

        <button type="submit">Submit</button>
      </form>

      {/* ✅ Success Dialog */}
      {showDialog && (
        <div className="dialog-overlay">
          <div className="dialog-box">
            <p>✅ Announcement created successfully!</p>
            <button onClick={handleDialogOk}>OK</button>
          </div>
        </div>
      )}

      {/* ✅ Global session expiry modal */}
      <SessionHandler />
    </div>
  );
};

export default CreateAnnouncement;
